import React from "react";
import { json } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import axios from "axios";

// Assets
import ogImage from "../assets/meta/headlockr-og-image.png";
import logo from "../assets/logo/logo.png";
import Blog from "../assets/blog/blog.webp";

// Components
import BlogCard from "../components/blog/BlogCard";
import Breadcrumbs from "../components/utils/Breadcrumb";

export async function loader({ context }) {
  const blogs = await axios.get(
    `${context.cloudflare.env.STRAPI_BASE_URL}/api/blogs?sort=id:desc&populate=*`,
    {
      headers: {
        Authorization: `Bearer ${context.cloudflare.env.STRAPI_API_TOKEN}`,
      },
    }
  );

  return json({ blogs: blogs.data || [] });
}

export const meta = () => {
  const og = new URL(ogImage, "https://headlockr.io").href;
  const logoUrl = new URL(logo, "https://headlockr.io").href;

  return [
    { title: "HeadLockr - Blog | Multi-Factor Authentication for Strapi CMS" },
    {
      property: "og:title",
      content: "HeadLockr - Blog | Multi-Factor Authentication for Strapi CMS",
    },
    {
      property: "og:description",
      content:
        "Welcome to the HeadLockr blog page. Stay tuned for the latest news and updates our native Strapi multifactor authentication and Strapi CMS security.",
    },
    { property: "og:url", content: "https://www.headlockr.com/blog" },
    { property: "og:image", content: og },
    {
      name: "description",
      content:
        "Welcome to the HeadLockr blog page. Stay tuned for the latest news and updates our native Strapi multifactor authentication and Strapi CMS security.",
    },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
    {
      name: "twitter:title",
      content: "HeadLockr - Blog | Multi-Factor Authentication for Strapi CMS",
    },
    {
      name: "twitter:description",
      content:
        "Welcome to the HeadLockr blog page. Stay tuned for the latest news and updates about multifactor authentication and Strapi CMS security.",
    },
    {
      name: "twitter:image",
      content: og,
    },
    { name: "twitter:site", content: "@headlockr" },
    {
      "script:ld+json": {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "CollectionPage",
            "@id": "https://headlockr.io/blog",
            url: "https://headlockr.io/blog",
            headline:
              "HeadLockr Blog - Multifactor Authentication for Strapi CMS",
            name: "HeadLockr Blog",
            description:
              "Welcome to the HeadLockr blog page. Stay tuned for the latest news and updates about multifactor authentication and Strapi CMS security.",
            thumbnailUrl: og,
            datePublished: "2024-01-01",
            dateModified: "2024-11-28",
            isPartOf: {
              "@id": "https://headlockr.io/#website",
            },
            image: {
              "@id": og,
            },
            inLanguage: "en-US",
            breadcrumb: {
              "@id": "https://headlockr.io/blog#breadcrumb",
            },
          },
          {
            "@type": "BreadcrumbList",
            "@id": "https://headlockr.io/blog#breadcrumb",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://headlockr.io/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blog",
                item: "https://headlockr.io/blog",
              },
            ],
          },
          {
            "@type": "WebSite",
            "@id": "https://headlockr.io/#website",
            url: "https://headlockr.io/",
            name: "HeadLockr",
            description: "Secure your Strapi CMS with HeadLockr",
            publisher: {
              "@id": "https://headlockr.io/#organization",
            },
            inLanguage: "en-US",
            copyrightHolder: {
              "@id": "https://headlockr.io/#organization",
            },
          },
          {
            "@type": "OnlineBusiness",
            "@id": "https://headlockr.io/#organization",
            name: "HeadLockr",
            legalName: "STRHUB B.V.",
            identifier: {
              "@type": "PropertyValue",
              propertyID: "KVK",
              value: "96493658",
            },
            description:
              "A company specializing in building secure software solutions for Strapi.",
            url: "https://headlockr.io",
            vatId: "NL867635307B01",
            telephone: "+31-20-1234567",
            email: "info@headlockr.io",
            logo: logoUrl,
            image: logoUrl,
            founder: {
              "@type": "Person",
              name: "Kevin Vugts",
              sameAs: "https://www.linkedin.com/in/kevin-v-b3b717131/",
            },
            foundingDate: "2024-01-01",
            foundingLocation: {
              "@type": "Place",
              name: "Goirle, Netherlands",
            },
            location: {
              "@type": "Place",
              name: "Goirle, Netherlands",
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "Parallelweg 14",
              addressLocality: "Goirle",
              addressRegion: "Noord-Brabant",
              postalCode: "5051HG",
              addressCountry: "NL",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+31-20-1234567",
              contactType: "customer support",
              email: "info@headlockr.io",
              areaServed: "Worldwide",
            },
            sameAs: [
              "https://twitter.com/headlockr",
              "https://linkedin.com/company/headlockr",
              "https://github.com/headlockr",
            ],
            slogan: "Secure your Strapi CMS with HeadLockr",
          },
        ],
      },
    },
  ];
};

export default function blog() {
  const data = useLoaderData();

  return (
    <div className="row pb-10">
      <div className="row mb-4 align-items-center">
        <div className="col-md-6">
          <h1 className="mb-2">Blogs</h1>
          <p>
            Welcome to the blog page. Here you can find all the latest news and
            updates about the Headlockr multifactor authentication plugin for
            Strapi. Stay tuned for more.
          </p>
        </div>
        <div className="col-md-6 d-flex align-items-cente justify-content-end">
          <img
            src={Blog}
            alt="blog"
            style={{
              width: 200,
              height: "auto",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
      <Breadcrumbs />

      {data?.blogs?.data?.map((blog, index) => (
        <BlogCard key={index} blog={blog} />
      ))}
    </div>
  );
}
